import "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";

class BarfUploadButton extends HTMLElement {
  connectedCallback() {
    if (this.renderRoot) return;

    this.renderRoot = this.attachShadow({ mode: "open" });

    const style = `
      button {
        position: relative;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        padding: 12px 24px;
        color: #fff;
        background-color:rgb(247, 127, 6);
        border: none;
        border-radius: 20px;
        transition: background 0.2s;
      }
      button:hover { background-color:rgba(247, 127, 6, 0.7); }
      button:active { background-color:rgba(247, 127, 6, 0.37); }
      button:focus { outline: none; }
      .output {
        margin-top: 12px;
        font-size: 14px;
        color: #333;
      }
    `;

    if ("adoptedStyleSheets" in Document.prototype && "replaceSync" in CSSStyleSheet.prototype) {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(style);
      this.renderRoot.adoptedStyleSheets = [sheet];
    } else {
      const s = document.createElement("style");
      s.textContent = style;
      this.renderRoot.append(s);
    }

    const button = document.createElement("button");
    button.textContent = this.getAttribute("label") || "Upload BARF File";
    this.output = document.createElement("div");
    this.output.className = "output";

    button.addEventListener("click", () => this.handleUpload());
    this.renderRoot.append(button, this.output);
  }

  async handleUpload() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".barf";
    input.style.display = "none";

    input.addEventListener("change", async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      this.output.innerHTML = "Processing...";

      const buffer = await file.arrayBuffer();
      const view = new DataView(buffer);
      const decoder = new TextDecoder("ascii");

      const remnantsOffset = Number(view.getBigUint64(0, true));
      let offset = remnantsOffset + 4 + 16 + 16;
      const numEntries = view.getUint32(offset, true);
      offset += 8;

      const entries = [];
      for (let i = 0; i < numEntries; i++) {
        const entryOffset = offset + i * 80;
        const nameBytes = new Uint8Array(buffer, entryOffset, 64);
        const fileName = decoder.decode(nameBytes).replace(/\0/g, "");
        const entryFileOffset = Number(view.getBigUint64(entryOffset + 64, true));
        const entryLength = Number(view.getBigUint64(entryOffset + 72, true));
        entries.push({ fileName, entryFileOffset, entryLength });
      }

      const zip = new JSZip();
      let cycleCount = 0;

      entries.forEach((entry) => {
        if (!entry.fileName) return;
        if (entry.fileName.toLowerCase().startsWith("cycle") && entry.fileName.toLowerCase().endsWith(".csv")) {
          const blobData = buffer.slice(entry.entryFileOffset, entry.entryFileOffset + entry.entryLength);
          zip.file(entry.fileName.replace(/[\/\\]/g, "_"), blobData);
          cycleCount++;
        }
      });

      if (cycleCount === 0) {
        this.output.innerHTML = "No Cycle CSV files found in this BARF file.";
        return;
      }

      this.output.innerHTML = "Creating ZIP...";
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipUrl = URL.createObjectURL(zipBlob);

      const a = document.createElement("a");
      a.href = zipUrl;
      a.download = "Cycle_CSV_Files.zip";
      a.textContent = `Download ${cycleCount} Cycle CSV File${cycleCount > 1 ? "s" : ""}`;
      Object.assign(a.style, {
        display: "block",
        marginTop: "10px",
        color: "#03a9f4",
        textDecoration: "none",
        fontWeight: "bold",
      });

      this.output.innerHTML = `<strong>Found ${cycleCount} Cycle CSV file${cycleCount > 1 ? "s" : ""}.</strong><br>`;
      this.output.append(a);
    });

    input.click();
  }
}

customElements.define("barf-upload-button", BarfUploadButton);
